export function wrapText(ctx: CanvasRenderingContext2D, text: string, maxWidth: number) {
  // Split on whitespace but keep it (so spacing stays natural)
  const tokens = text.split(/(\s+)/).filter(t => t.length > 0);

  const lines = [];
  let line = "";

  const measure = (s: string) => ctx.measureText(s).width;

  for (const token of tokens) {
    const testLine = line + token;

    if (line === "" || measure(testLine) <= maxWidth) {
      line = testLine;
      continue;
    }

    // Current token doesn't fit on this line → push current line
    lines.push(line.trimEnd());
    line = "";

    // Token itself might be longer than maxWidth (long word / url)
    if (measure(token) <= maxWidth) {
      line = token;
    } else {
      // Break the token by characters (simple and reliable)
      let chunk = "";
      for (const ch of token) {
        const testChunk = chunk + ch;
        if (chunk !== "" && measure(testChunk) > maxWidth) {
          lines.push(chunk);
          chunk = ch;
        } else {
          chunk = testChunk;
        }
      }
      line = chunk;
    }
  }

  if (line) lines.push(line.trimEnd());
  return lines;
}

export function drawWrappedText(ctx: CanvasRenderingContext2D, text: string, x: number, y: number, maxWidth: number, lineHeight: number) {
  const lines = wrapText(ctx, text, maxWidth);
  for (let i = 0; i < lines.length; i++) {
    ctx.fillText(lines[i], x, y + i * lineHeight);
  }
  return lines.length;
}